/**
 * Password validation matching Cognito user pool policy.
 *
 * Policy (cognito-user-pool.yaml):
 *   MinimumLength: 8
 *   RequireLowercase: true
 *   RequireUppercase: true
 *   RequireNumbers: true
 *   RequireSymbols: false
 */

import i18n from '@/i18n';

export interface PasswordCheck {
  label: string;
  met: boolean;
}

export interface PasswordValidation {
  isValid: boolean;
  checks: PasswordCheck[];
}

export function validatePassword(password: string): PasswordValidation {
  const checks: PasswordCheck[] = [
    { label: i18n.t('password.minLength'), met: password.length >= 8 },
    { label: i18n.t('password.uppercase'), met: /[A-Z]/.test(password) },
    { label: i18n.t('password.lowercase'), met: /[a-z]/.test(password) },
    { label: i18n.t('password.number'), met: /[0-9]/.test(password) },
  ];

  return {
    isValid: checks.every((c) => c.met),
    checks,
  };
}
